import { EntPopulationFilter } from "../../../models/filters/populationFilter";
import { EntPopulation } from "../../../models/population";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
export const populationApi = agroApi.injectEndpoints({
    endpoints: (builder) => ({

        getPopulationListAll: builder.query<ResponseDataGet<EntPopulation>, EntPopulationFilter>({
          query: (filter) => ({
            url: "/population/get-all",
            method: "POST",
            body: JSON.stringify(filter)
          }),
        }),
        getPopulationList: builder.query<ResponseDataGet<EntPopulation>, void>({
            query: (id) => ({
              url: "/population/get-all",
                method: 'GET'
            })
        }),
        getPopulationById: builder.query<ResponseDataTest<EntPopulation>, number>({
          query: (id) => ({
              url: `/population/${id}`,
              method: 'GET'
          })
      }),
        addPopulation: builder.mutation<ResponseDataTest<EntPopulation>, EntPopulation>({
            query: (body) => ({
              url: `/population`,
              method: "POST",
              body: JSON.stringify(body)
            }),
            onQueryStarted: async (user, { dispatch, queryFulfilled }) => {
              try {
      
              } catch { }
            }
          }),
          editPopulation: builder.mutation<ResponseDataTest<EntPopulation>, EntPopulation>({
            query: (body, ) => ({
              url: `/population`,
              method: 'PUT',
              body: JSON.stringify(body),
            }),
            onQueryStarted: async (user, { dispatch, queryFulfilled }) => {}
          }),
          deletePopulation: builder.mutation<ResponseDataTest<EntPopulation>, number>({
            query: (id) => ({
              url: `/population/${id}`,
              method: 'DELETE',
            }),
            onQueryStarted: async (id, { dispatch, queryFulfilled }) => { }
          }),
    }),
    overrideExisting: false,
});

export const {
useAddPopulationMutation,
useDeletePopulationMutation,
useEditPopulationMutation,
useGetPopulationByIdQuery,
useGetPopulationListQuery,
useLazyGetPopulationListAllQuery
} = populationApi;
